import React from "react";
import { FormattedMessage } from "react-intl";
import * as Collapsible from "@radix-ui/react-collapsible";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { Link, Paragraph } from "@trainline/depot-web";
import IconAlert from "../../assets/icons/IconAlert";
import IconChevron from "../../assets/icons/IconChevron";
import useTSILeg from "../../hooks/useTSILeg";
import isDisruption from "../../utils/disruptions/isDisruption";
import * as s from "./DisruptionsAlert.module.css";
const getContentWidth = (numberOfDisruptions) => {
  if (numberOfDisruptions === 2)
    return { width: "50%", minWidth: "310px" };
  if (numberOfDisruptions >= 3)
    return { width: "45%", minWidth: "310px" };
  return { width: "100%" };
};
const DisruptionsAlert = ({ legId }) => {
  var _a;
  const tsiLeg = useTSILeg(legId);
  const disruptions = ((_a = tsiLeg == null ? void 0 : tsiLeg.disruptions) == null ? void 0 : _a.filter(isDisruption)) || [];
  if (!(disruptions == null ? void 0 : disruptions.length)) {
    return null;
  }
  const shouldStartExpanded = !!(tsiLeg == null ? void 0 : tsiLeg.firstDisruption);
  return /* @__PURE__ */ React.createElement(Collapsible.Root, {
    defaultOpen: shouldStartExpanded,
    className: s.root
  }, /* @__PURE__ */ React.createElement(Collapsible.Trigger, {
    className: s.trigger
  }, /* @__PURE__ */ React.createElement(Paragraph, {
    typeStyle: "body",
    fontWeight: "bold",
    className: s.title
  }, /* @__PURE__ */ React.createElement(IconAlert, null), /* @__PURE__ */ React.createElement(FormattedMessage, {
    id: "disruptionAlert.title"
  })), /* @__PURE__ */ React.createElement(IconChevron, {
    className: s.chevron
  })), /* @__PURE__ */ React.createElement(Collapsible.Content, {
    className: s.content
  }, /* @__PURE__ */ React.createElement(ScrollArea.Root, null, /* @__PURE__ */ React.createElement(ScrollArea.Viewport, null, /* @__PURE__ */ React.createElement("div", {
    className: s.slider
  }, disruptions.map(({ id, message, trainlineUrl: url }) => /* @__PURE__ */ React.createElement(Paragraph, {
    key: id
  }, /* @__PURE__ */ React.createElement(Link, {
    className: s.box,
    href: url != null ? url : void 0,
    inherit: true
  }, /* @__PURE__ */ React.createElement("div", {
    className: s.message,
    style: getContentWidth(disruptions.length)
  }, message, /* @__PURE__ */ React.createElement(IconChevron, {
    className: s.chevronlink
  }))))))), /* @__PURE__ */ React.createElement(ScrollArea.Scrollbar, {
    orientation: "horizontal"
  }))));
};
var DisruptionsAlert_default = DisruptionsAlert;
export {
  DisruptionsAlert_default as default
};
